import ItemPlugin from "./LinkItem/LinkItem";
import { processRawInput, restartItemProcessing } from "./processRawInput";
import userShare from "./userShare";

export default function registerLinkPlugin() {
  return { ItemPlugin, userShare, processRawInput, restartItemProcessing };
}
